import axios from "./axios";
import language from "./language";

interface District {
    id: number;
    name: string;
    country_id: number;
    created_at: string;
    updated_at: string;
}

export default async (country_id: number): Promise<District[]> => {
    const { data } = await axios.get("general/district/list", {
        params: {
            country_id: country_id,
            lang: language()
        }
    });

    if (data.message == "OK") {
        return data.data;
    }
    return [];
}
